var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"star-widget"},[(_vm.loading || !_vm.currentRating)?_c('div',{staticClass:"lds-ring pl-8 mr-4"},[_c('div'),_c('div'),_c('div'),_c('div')]):_c('div',[_c('div',{staticClass:"star-widget__header"},[_c('p',[_vm._v("Total Avg: "+_vm._s(_vm.currentRating.avg_rating)+" out of 5")]),_c('p',{staticClass:"star-widget__total"},[_vm._v(" "+_vm._s(_vm.currentRating.total_count)+" global ratings ")])]),_c('vue-apex-charts',{staticClass:"star-widget__graph",attrs:{"type":"bar","height":"180","options":_vm.options,"series":[
        {
          name: 'Ratings',
          data: [
            _vm.currentRating['5'],
            _vm.currentRating['4'],
            _vm.currentRating['3'],
            _vm.currentRating['2'],
            _vm.currentRating['1'],
          ],
        },
      ]}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }